// Copyright (c) 2022 by Move Closer

/**
 * Prefix for the `[id]` attribute value of the `<UiContainer>'s` root HTML element.
 *
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const UI_CONTAINER_ID_ATTR_PREFIX: string = 'c_'

/**
 * Injection key used to bind the `@Provide` and `@Inject` decorators that share and control the information about
 * the containers' mounting status.
 *
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const ALL_CONTAINERS_MOUNTED_INJECTION_KEY = Symbol.for('ALL_CONTAINERS_MOUNTED_INJECTION_KEY')

/**
 * The name of the event emitted by the `<UiContainer>` component
 * to the `EventBus` service in its `mounted()` lifecycle hook.
 *
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const UI_CONTAINER_MOUNTED_EVENTBUS_EVENT_NAME: string = 'ui:Container.mounted'
